import * as React from "react";
import { Field } from "@grandvisionhq/forms";
import ControlledCheckbox from "../../../../ControlledCheckbox/v3/components/ConsentsAndOptIns/CheckboxField/ControlledCheckbox/ControlledCheckbox.js";
/* empty css                   */
const CheckboxField = ({
  label,
  "data-t": dataT,
  "aria-label": ariaLabel,
  ...rest
}) => /* @__PURE__ */ React.createElement(Field, { ...rest }, /* @__PURE__ */ React.createElement(
  ControlledCheckbox,
  {
    id: rest.id ?? rest.name,
    name: rest.name,
    "data-t": dataT,
    "aria-label": ariaLabel,
    label
  }
));
export {
  CheckboxField as default
};
//# sourceMappingURL=CheckboxField.js.map
